import React, {Component} from 'react';
import {Link} from "react-router-dom";
import logo_small from '../../logo_small.svg';
import email from '../../assets/icons/email.svg';
import key from '../../assets/icons/key.svg';
import eye from '../../assets/icons/eye.svg';
import eyeclose from '../../assets/icons/eye-closed.svg';
import done_icon from '../../assets/icons/done_icon.svg';
import error_icon from '../../assets/icons/error.svg';
import {Col, Container, Form, Label, Row} from "react-bootstrap";
import {validate} from "../helpers";
import CarouselBanner from "./components/CarouselBanner";
import Copyright from "../layouts/Copyright";


class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {
            new_password: "",
            show_password: false,
            input: {},
            errors: {}

        }
        this.handleShowPassword = this.handleShowPassword.bind(this)
        this.handleChangeText = this.handleChangeText.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleShowPassword(e) {
        this.setState({show_password: this.state.show_password ? false : true})
    }


    handleChangeText(event) {

        let input = this.state.input;
        input[event.target.name] = event.target.value;

        this.setState({
            input
        });
        let validated = validate(this.state.input)
        this.setState({errors: validated.errors})
    }

    handleSubmit(event) {
        let validated = validate(this.state.input)
        if (validated.is_valid) {
            return true
        }
        event.preventDefault();
        this.setState({errors: validated.errors})
        return false
    }

    render() {
        return (
            <div>
                <div className="login_section">
                    <Container fluid className="h-100">
                        <Row className="h-100">
                            <Col md={12} lg={10} className="mt-auto mb-auto">
                                <div className="div_login">
                                    <div className="logo_small">
                                        <img src={logo_small} alt="Logo"/>
                                    </div>
                                    <h1>Welcome To <span>Serve</span>Easy</h1>
                                    <p> To keep connected with us please login with your personal
                                        information by email address and password
                                    </p>
                                </div>
                                <div className="login_form">
                                    <Form className="main_form" onSubmit={this.handleSubmit} action="/home"
                                          method="GET">
                                        <Form.Group className="form_box first">
                                            <div className="svg_icon">
                                                <img src={email} alt="email_icon"/>
                                            </div>
                                            <Form.Label>Email address</Form.Label>
                                            <Form.Control type="text" placeholder="johndoe@serveeasy.com" required
                                                          id="email"
                                                          onChange={this.handleChangeText} name="email"/>
                                            <div
                                                className={this.state.errors.email ? "error_danger icon_last" : "icon_last"}>
                                                {this.state.errors.email ?
                                                    <img src={error_icon} alt="error_icon"/> :
                                                    <img src={done_icon} alt="done_icon"/>
                                                }
                                            </div>
                                        </Form.Group>
                                        <Form.Group className="form_box last">
                                            <div className="svg_icon">
                                                <img src={key} alt="key_icon"/>
                                            </div>
                                            <Form.Label>Password</Form.Label>
                                            <Form.Control type={this.state.show_password ? "text" : "password"}
                                                          placeholder="****************"
                                                          onChange={this.handleChangeText}/>
                                            <div className="icon_last">
                                                {this.state.show_password ?
                                                    <img src={eye} alt="eye_icon" onClick={this.handleShowPassword}/> :
                                                    <img src={eyeclose} alt="eyeclose"
                                                         onClick={this.handleShowPassword}/>
                                                }
                                            </div>
                                        </Form.Group>
                                        <div className="check_box">
                                            <Form.Group className="form_check" controlId="formBasicCheckbox">
                                                <Form.Check type="checkbox" label="Remember Me"/>
                                            </Form.Group>
                                            <Link to="" className="forget_pass">Forget Password?</Link>
                                        </div>
                                        <Form.Group className="form-submit">
                                            <Form.Control type="submit" className="submit_style" value="Sign In"/>
                                            <Link to="/create-account" className="creat_btn">Create An Account</Link>
                                        </Form.Group>

                                    </Form>
                                </div>
                            </Col>
                        </Row>
                    </Container>


                </div>
                <CarouselBanner/>
                <Copyright/>
            </div>
        );
    }
}

export default Login;